import React, { useMemo } from 'react';
import { isUndefined, noop } from 'lodash/fp';

import { ConfirmationModal } from '../../shared/modal/ConfirmationModal';
import { ModalHeader } from '../../shared/modal/ModalHeader';
import { Engine } from '../../shared/icons';
import styles from './NettingEngine.module.scss';
import { ProductTypeCovered, ProductTypeCoveredEnum } from './store';
import { WYSIWYG } from '../../shared/wysiwyg/WYSIWYG';

interface NettingEngineConditionModalProps {
    isOpen: boolean;
    closeModal: () => void;
    productCovered: ProductTypeCovered;
}

export const NettingEngineConditionModal: React.FC<NettingEngineConditionModalProps> = ({ isOpen, closeModal, productCovered }) => {
    const { product, conditions, notes, covered } = productCovered;

    const conditionsMessage = useMemo(() => {
        if (covered === ProductTypeCoveredEnum.NO) {
            return 'It is not possible to provide information about this product type, as it is not covered by the opinion';
        }
        if (conditions === 'Yes') {
            return 'Close-Out Netting is effective for this product';
        }
        if (conditions === 'No') {
            return 'Close-Out Netting is not effective for this product';
        }
        if (conditions === 'Yes - with exceptions') {
            return 'For this product, Close-Out Netting is effective, with certain exceptions.';
        }
        if (conditions === 'No - with exceptions') {
            return 'For this product, Close-Out Netting is not effective, with certain exceptions.';
        }
        if (conditions === 'Unclear') {
            return 'For this product, it is unclear whether Close-Out Netting is effective';
        }
        if (conditions === 'Not applicable') {
            return 'For this product, Close-Out Netting is not applicable';
        }
    }, [conditions, covered]);

    return (
        <ConfirmationModal
            isOpen={isOpen}
            closeModal={closeModal}
            showConfirm={false}
            closeLabel='Close'
            zIndex={12}
        >
            <div className={styles.sectionTenAModalWrapper}>
                <ModalHeader
                    testId='netting-engine-conditions-modal'
                    label={product}
                    icon={Engine}
                />
                {conditions && <div className={styles.modalContent}>{conditionsMessage}</div>}
                {isUndefined(notes) ? <div className={styles.modalContent}>There are no additional notes added regarding this product type</div> :
                    <>
                        <div className={styles.modalContent}>Notes:</div>
                        <WYSIWYG isReadOnly updateContent={noop} content={notes} toolbarHidden showBorder={false} />
                    </>
                }
            </div>
        </ConfirmationModal>
    );
};
